import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdcDialogRef } from '@angular-mdc/web';
import { SanityService } from 'src/app/sanity.service';

@Component({
  selector: 'app-sjekkliste-dagsoppgjor',
  templateUrl: './sjekkliste-dagsoppgjor.component.html',
  styleUrls: ['./sjekkliste-dagsoppgjor.component.scss']
})
export class SjekklisteDagsoppgjorComponent implements OnInit {

  public sjekklistepunkter: { title: string }[] = [];
  public pending = true;

  public form = new FormGroup({
    sjekkliste: new FormArray([]),
    kommentar: new FormControl(null)
  });

  get sjekklisteArray(): FormArray {
    return this.form.get('sjekkliste') as FormArray;
  }

  constructor(
    private sanityService: SanityService,
    private dialogRef: MdcDialogRef<SjekklisteDagsoppgjorComponent>
  ) {}

  get kommentarErPakrevd(): boolean {
    return this.sjekklisteArray.controls.some(c => !c.value);
  }

  ngOnInit() {
    this.sanityService.fetch<{ title: string }[]>(
      `*[_type == "dagsoppgjor"][0].sjekkliste`
    ).subscribe(
      punkter => {
        this.sjekklistepunkter = punkter || [];
        this.sjekklistepunkter.forEach(() => {
          this.sjekklisteArray.push(new FormControl(false));
        });
        this.oppdaterKommentarValidator();
        this.sjekklisteArray.valueChanges.subscribe(() => this.oppdaterKommentarValidator());
        this.pending = false;
      },
      () => {
        this.pending = false;
      }
    );
  }

  private oppdaterKommentarValidator() {
    const kommentar = this.form.get('kommentar');
    if (!kommentar) { return; }
    if (this.kommentarErPakrevd) {
      kommentar.setValidators([Validators.required]);
    } else {
      kommentar.clearValidators();
    }
    kommentar.updateValueAndValidity();
  }

  gaVidere() {
    const sjekkliste = this.sjekklistepunkter.map((punkt, i) => ({
      title: punkt.title,
      checked: this.sjekklisteArray.at(i).value as boolean
    }));
    this.dialogRef.close({
      accept: true,
      sjekkliste,
      kommentar: this.form.value.kommentar
    });
  }
}
